export default "__VITE_ASSET__B77aZz8n__"